/**
 * AjaxItem
 * @param item
 * @param getData
 * @param params
 * @param otherContainer
 * @constructor
 */
window.AjaxItem = function(item, getData, params, otherContainer) {
  if (typeof item != 'string') {
    return;
  }
  if (typeof params != 'object') {
    params = {};
  }

  getData = getData || {};
  const self = this;

  let containerList = '#list_' + item;
  if (otherContainer) {
    containerList = '#list_' + otherContainer;
  }

  const defaults = {
    container: containerList,
    ajaxFile: BASE_PATH + 'ajax/list/ajax.' + item,
    callback: function() {
    },
  };
  let config = $.extend(defaults, params);

  /**
   * sortBy
   * @param sortby
   */
  this.sortBy = function(sortby) {
    self.updater({sortby: sortby});
  };

  /**
   * changePage
   * @param page
   */
  this.changePage = function(page) {
    self.updater({page: page});
  };

  /**
   * Fügt weitere Elemente aus einem Object hinzu, um diese mit einem späteren Aufruf von updater() zu berücksichtigen
   * @param name
   * @param filter
   */
  this.addFilter = function(name, filter) {
    if (typeof filter == 'object') {
      let filt = [];
      $(filter).each(function() {
        filt[filt.length] = $(this).val();
      });

      let temp = {};
      temp[name] = filt;
      getData = $.extend({}, getData, temp);
    }
  };

  /**
   * loader
   */
  this.loader = function() {
    $.ajax({
      url: config.ajaxFile + '?' + $.param(getData),
      beforeSend: function() {
        $(config.container).html('').css('min-height', '100px');
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html).css('min-height', '1px');
        self.afterLoad();
      },
    });
  };

  /**
   * updater
   * @param getUpdater
   */
  this.updater = function(getUpdater) {
    let data = (typeof getUpdater != 'undefined' ? getUpdater : {});
    data = $.extend(data, {ajax: 1});

    $.ajax({
      url: config.ajaxFile + '?' + $.param(getData),
      type: 'get',
      data: data,
      beforeSend: function() {
        $(config.container).html('').css('min-height', '100px');
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html).css('min-height', '1px');
        self.afterLoad();
      },
    });
  };

  /**
   * poster
   * @param postData
   */
  this.poster = function(postData) {
    let data = (typeof postData != 'undefined' ? postData : {});
    data = $.extend(data, {ajax: 1});
    $.ajax({
      url: config.ajaxFile,
      type: 'post',
      data: data,
      beforeSend: function() {
        $(config.container).html('').css('min-height', '100px');
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html).css('min-height', '1px');
        self.afterLoad();
      },
    });
  };

  /**
   * afterLoad
   */
  this.afterLoad = function() {
    if (typeof config.callback == 'function') {
      config.callback();
      $('body').find('div.ajaxLoader').remove();
    }
  };

  /**
   * showLoader
   */
  this.showLoader = function() {
    insertAutoLoader($(config.container));
  };
};

/**
 * insertAutoLoader
 * @param into
 */
window.insertAutoLoader = function(into) {
  $(into).append('<div class="ajaxLoader"><div class="lds-ripple"><div></div><div></div></div></div>');
};

/**
 * ajaxDialog
 * @param file
 * @param maxWidth
 * @param params
 */
window.ajaxDialog = function(file, maxWidth, params) {
  const self = $(this);
  const body = $('body');

  // Default für maxWidth des PopUps definieren
  maxWidth = maxWidth || 742;

  // Close-Icon
  const closeHtml = '<button type="button" class="btn-close" aria-label="Close" onclick="ajaxDialog(\'close\');"></button>';

  /**
   * show
   */
  self.show = function() {
    // modal backdrop
    const popUpBackDrop = $('body .modal-backdrop');
    if (popUpBackDrop.length === 0) {
      body.append('<div class="modal-backdrop show"></div>');
    }

    body.append('<div class="modal d-block" tabindex="-1"><div class="modal-dialog" style="max-width:' + maxWidth + 'px;"><div class="modal-content"></div></div></div>');

    const popup = $('body .modal').last();

    if (typeof file == 'string') {
      self.loadData();
    }
    if (typeof file == 'object') {
      popup.find('.modal-content').html(file.html());
    }

    checkOpenDialog();
  };

  /**
   * loadData
   */
  self.loadData = function() {
    $.ajax({
      url: file,
      type: 'post',
      data: config.post_data,
      beforeSend: function() {
        insertAutoLoader($('body .modal').last().find('.modal-content'));
      },
      success: function(html) {
        const popup = $('body .modal').last().find('.modal-content');
        popup.html(html).find('.modal-header').append(closeHtml);

        if (popup.find('form').attr('action') === '') {
          popup.find('form:first').submit(function() {
            config.post_data = $(this).find('input:not([type=checkbox],[type=radio],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select');

            self.loadData();
            return false;
          });
        }

        if (typeof config.callback == 'function') {
          config.callback();
        }

        popup.find('input:visible, select:visible, textarea:visible, button:visible:not(.btn-close)').first().focus();
      },
    });
  };

  /**
   * close
   */
  self.close = function() {
    const popUpWrap = $('body .modal');

    popUpWrap.last().remove();
    if ($('body .modal ').length === 0) {
      $('body .modal-backdrop').remove();
    }

    checkOpenDialog();
  };

  // Hier gehts los
  if (typeof file == 'object' && $(file).attr('href')) {
    file = $(file).attr('href');
  } else if (typeof file == 'object') {
    file = $(file);
  }

  if (file === 'close') {
    self.close();
    return;
  }

  if (typeof params != 'object') {
    params = {};
  }

  const defaults = {
    width: 0,
    callback: function() {
    },
    post_data: {},
  };
  const config = $.extend(defaults, params);

  self.show();
};

/**
 * checkOpenDialog
 */
window.checkOpenDialog = function() {
  const popupWrap = $('.modal');
  const body = $('body');
  if (popupWrap.length) {
    if (!body.hasClass('overflow-hidden')) {
      body.addClass('overflow-hidden');
    }
  } else {
    if (body.hasClass('overflow-hidden')) {
      body.removeClass('overflow-hidden');
    }
  }
};

/**
 * Init Simple Calendar
 * @param listElement
 * @param inputElement
 * @param params
 */
window.initCalendar = function(listElement, inputElement, params = {}) {
  // Load Calendar
  $.ajax({
    url: BASE_PATH + 'ajax/helper/ajax.getCalendar?init=1',
    type: 'get',
    data: params,
    beforeSend: function() {
      $(listElement).html('');
      insertAutoLoader($(listElement));
    },
    success: function(html) {
      $(listElement).html(html);
      selectDay(inputElement);
    },
  });

  // Update Calendar
  window.updateCalendar = function(listElement, inputElement, params) {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/ajax.getCalendar',
      type: 'get',
      data: params,
      beforeSend: function() {
        insertAutoLoader($(listElement));
      },
      success: function(html) {
        $(listElement).html(html);
        selectDay(inputElement);
      },
    });
  };

  /**
   * Select Day
   * @param inputElement
   */
  window.selectDay = function(inputElement) {
    // Selected
    $('.calendar-month-days .selectable').on('click', function() {
      $('.calendar-month-days').find('.selected').removeClass('selected');

      $(inputElement).val($(this).data('value'));
      $('#booking-date-output').html($(this).data('value-output'));
      $(this).addClass('selected');

      updateCalendar(listElement, inputElement, {
        'selectedDate': $(this).data('value'),
      });

      const wareList = $('#ware-list');
      const wareIDs = Array();
      wareList.find('input[type="checkbox"]').each(function() {
        if ($(this).is(':checked')) {
          wareIDs.push($(this).val());
        }
      });

      ListBuchungTime.updater({
        'selectedDate': $(this).data('value'),
        'wareList': wareIDs,
      });
    });
  };

  /**
   * Update Month
   * @param element
   */
  window.updateMonthSelect = function(element) {
    updateCalendar(listElement, inputElement, {
      'selectedMonth': $(element).val(),
    });
  };

  /**
   * Update Year
   * @param element
   */
  window.updateYearSelect = function(element) {
    updateCalendar(listElement, inputElement, {
      'selectedYear': $(element).val(),
    });
  };

  /**
   * updateDateSwitcher
   * @param year
   * @param month
   */
  window.updateDateSwitcher = function(year, month) {
    const calendarContainer = $('#calendar-container');

    const firstYear = calendarContainer.data('first-year');
    const lastYear = calendarContainer.data('last-year');

    const yearSwitcher = $('#year-switcher');
    const monthSwitcher = $('#month-switcher');
    const prevSwitcher = $('#prev-switcher');
    const nextSwitcher = $('#next-switcher');

    yearSwitcher.val(year);
    monthSwitcher.val(month);

    if ((parseInt(year) === firstYear) && (parseInt(month) === 1)) {
      prevSwitcher.attr('disabled', 'disabled');
    } else {
      prevSwitcher.removeAttr('disabled');
    }

    if ((parseInt(year) === lastYear) && (parseInt(month) === 12)) {
      nextSwitcher.attr('disabled', 'disabled');
    } else {
      nextSwitcher.removeAttr('disabled');
    }

    prevSwitcher.unbind('click');
    prevSwitcher.on('click', function() {
      let newMonth = parseInt(month) - 1;
      let newYear = parseInt(year);

      if (newMonth === 0) {
        newYear = newYear - 1;
        newMonth = 12;
      }

      updateCalendar(listElement, inputElement, {
        'selectedYear': newYear,
        'selectedMonth': newMonth,
      });

      updateDateSwitcher(newYear, newMonth);

      return false;
    });

    nextSwitcher.unbind('click');
    nextSwitcher.on('click', function() {

      let newMonth = parseInt(month) + 1;
      let newYear = parseInt(year);

      if (newMonth === 13) {
        newYear = newYear + 1;
        newMonth = 1;
      }

      updateCalendar(listElement, inputElement, {
        'selectedYear': newYear,
        'selectedMonth': newMonth,
      });

      updateDateSwitcher(newYear, newMonth);

      return false;
    });
  };

  /**
   * Delete Date
   * @param currentDate
   */
  window.deleteDate = function(currentDate) {
    const yearSwitcher = $('#year-switcher');
    const monthSwitcher = $('#month-switcher');
    const monthDays = $('.calendar-month-days');
    monthDays.find('.selected').removeClass('selected');

    const newMonth = currentDate.split('-');
    monthSwitcher.val(newMonth[1]);
    yearSwitcher.val(newMonth[0]);

    $(inputElement).val('');
    $('#booking-date-output').html('');

    updateCalendar(listElement, inputElement, {
      'selectedYear': newMonth[0],
      'selectedMonth': newMonth[1],
      'selectedDate': '',
    });

    ListBuchungTime.updater({
      'selectedDate': '',
    });
  };

  /**
   * Select Today
   * @param currentDate
   * @param currentDateOutput
   */
  window.selectCurrentDate = function(currentDate, currentDateOutput) {
    const monthSwitcher = $('#month-switcher');
    const yearSwitcher = $('#year-switcher');
    const monthDays = $('.calendar-month-days');
    monthDays.find('.selected').removeClass('selected');

    const newMonth = currentDate.split('-');
    monthSwitcher.val(newMonth[1]);
    yearSwitcher.val(newMonth[0]);

    $(inputElement).val(currentDate);
    $('#booking-date-output').html(currentDateOutput);

    updateCalendar(listElement, inputElement, {
      'selectedYear': newMonth[0],
      'selectedMonth': newMonth[1],
      'selectedDate': currentDate,
    });

    ListBuchungTime.updater({
      'selectedDate': currentDate,
    });
  };

  /**
   * select time
   * @param element
   * @param from
   * @param to
   * @param gossenID
   */
  window.selectTime = function(element, from, to, gossenID) {
    // Reset
    $('#time-range').find('button').removeClass('btn-success').addClass('btn-outline-success');
    $('#booking-day-from, #booking-day-to').val('');

    // Set
    $(element).removeClass('btn-outline-success').addClass('btn-success');
    $('#booking-day-from').val(from);
    $('#booking-day-to').val(to);
    $('#booking-time-output').html(pad(from, '00') + ':00 - ' + pad(to, '00') + ':00 Uhr');
    $('#booking-gossen-id').val(gossenID);

    openBooking();
  };
};

/**
 * Init Simple Calendar
 * @param listElement
 * @param inputElement
 * @param params
 */
window.initCalendarAdmin = function(listElement, inputElement, params = {}) {
  // Load Calendar
  $.ajax({
    url: BASE_PATH + 'ajax/helper/ajax.getCalendarAdmin?init=1',
    type: 'get',
    data: params,
    beforeSend: function() {
      $(listElement).html('');
      insertAutoLoader($(listElement));
    },
    success: function(html) {
      $(listElement).html(html);
      selectAdminDay(inputElement);
    },
  });

  // Update Calendar
  window.updateAdminCalendar = function(listElement, inputElement, params) {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/ajax.getCalendarAdmin',
      type: 'get',
      data: params,
      beforeSend: function() {
        $(listElement).html('');
        insertAutoLoader($(listElement));
      },
      success: function(html) {
        $(listElement).html(html);
        selectAdminDay(inputElement);
      },
    });
  };

  /**
   * Select Day
   * @param inputElement
   */
  window.selectAdminDay = function(inputElement) {
    // Selected
    $('.calendar-month-days .selectable').on('click', function() {
      $('.calendar-month-days').find('.selected').removeClass('selected');

      $(inputElement).val($(this).data('value'));
      $('#booking-date-output').html($(this).data('value-output'));
      $(this).addClass('selected');

      updateAdminCalendar(listElement, inputElement, {
        'selectedDate': $(this).data('value'),
      });
    });
  };

  /**
   * Update Month
   * @param element
   */
  window.updateAdminMonthSelect = function(element) {
    updateAdminCalendar(listElement, inputElement, {
      'selectedMonth': $(element).val(),
    });
  };

  /**
   * Update Year
   * @param element
   */
  window.updateAdminYearSelect = function(element) {
    updateAdminCalendar(listElement, inputElement, {
      'selectedYear': $(element).val(),
    });
  };

  /**
   * updateDateSwitcher
   * @param year
   * @param month
   */
  window.updateAdminDateSwitcher = function(year, month) {
    const calendarContainer = $('#calendar-container');
    const yearSwitcher = $('#year-switcher');
    const lastYear = calendarContainer.data('last-year');
    const monthSwitcher = $('#month-switcher');
    const prevSwitcher = $('#prev-switcher');
    const nextSwitcher = $('#next-switcher');

    yearSwitcher.val(year);
    monthSwitcher.val(month);

    if ((parseInt(year) === calendarContainer.data('first-year')) && (parseInt(month) === 1)) {
      prevSwitcher.attr('disabled', 'disabled');
    } else {
      prevSwitcher.removeAttr('disabled');
    }

    if ((parseInt(year) === lastYear) && (parseInt(month) === 12)) {
      nextSwitcher.attr('disabled', 'disabled');
    } else {
      nextSwitcher.removeAttr('disabled');
    }

    prevSwitcher.unbind('click');
    prevSwitcher.on('click', function() {

      let newMonth = parseInt(month) - 1;
      let newYear = parseInt(year);

      if (newMonth === 0) {
        newYear = newYear - 1;
        newMonth = 12;
      }

      updateAdminCalendar(listElement, inputElement, {
        'selectedYear': newYear,
        'selectedMonth': newMonth,
      });

      updateAdminDateSwitcher(newMonth, newYear);

      return false;
    });

    nextSwitcher.unbind('click');
    nextSwitcher.on('click', function() {

      let newMonth = parseInt(month) + 1;
      let newYear = parseInt(year);

      if (newMonth === 13) {
        newYear = newYear + 1;
        newMonth = 1;
      }

      updateAdminCalendar(listElement, inputElement, {
        'selectedYear': newYear,
        'selectedMonth': newMonth,
      });

      updateAdminDateSwitcher(newMonth);

      return false;
    });
  };
};

/**
 * pad
 * @param num
 * @param field
 * @returns {string}
 */
window.pad = function(num, field) {
  const n = '' + num;
  const w = n.length;
  const l = field.length;
  const pad = w < l ? l - w : 0;

  return field.substr(0, pad) + n;
};

/**
 * openBooking
 */
window.openBooking = function(fromWare = false) {
  const bookingButton = $('#booking-button');
  const wareList = $('#ware-list');

  bookingButton.attr('disabled', 'disabled');
  wareList.find('input[type="checkbox"]').removeAttr('disabled');

  let hasCheckedData = false;
  let count = 0;

  const wareIDs = Array();
  wareList.find('input[type="checkbox"]').each(function() {
    if ($(this).is(':checked')) {
      hasCheckedData = true;
      count++;

      wareIDs.push($(this).val());
    }
  });

  if (count === 2) {
    wareList.find('input[type="checkbox"]').not(':checked').attr('disabled', 'disabled');
  }

  if (fromWare === true) {
    ListBuchungTime.updater({
      'selectedDate': $('#booking-date').val(),
      'wareList': wareIDs,
    });
  }

  if (hasCheckedData === true && $('#booking-day-from').val() !== '') {
    bookingButton.removeAttr('disabled');
  }
};

/**
 * checkAdminTime
 * @param fromWare
 */
window.checkAdminTime = function(fromWare = false) {
  const wareList = $('#ware-list');
  const wareIDs = Array();
  wareList.find('input[type="checkbox"]').each(function() {
    if ($(this).is(':checked')) {
      wareIDs.push($(this).val());
    }
  });

  if (fromWare === true) {
    ListAdminBuchungTime.updater({
      'selectedDate': $('#uDate').val(),
      'wareList': wareIDs,
    });
  }
};

/**
 * select time
 * @param element
 * @param from
 * @param to
 * @param gossenID
 */
window.selectAdminTime = function(element, from, to, gossenID) {
  // Reset
  $('#time-range').find('button').removeClass('btn-success').addClass('btn-outline-success');
  $('#edit-time-from, #edit-time-to').val('');

  // Set
  $(element).removeClass('btn-outline-success').addClass('btn-success');
  $('#edit-time-from').val(from);
  $('#edit-time-to').val(to);
  $('#edit-gossen-id').val(gossenID);
};

/**
 * change admin time
 * @param element
 */
window.changeAdminTime = function(element) {
  ListAdminBuchungTime.updater({
    'selectedDate': $(element).val(),
  });
};

/**
 * init tooltip
 */
window.initTooltip = function() {
  const tooltipTheme = 'tooltipster-borderless';
  const tooltipTypes = {
    'top': '.tooltip-top',
    'right': '.tooltip-right',
    'bottom': '.tooltip-bottom',
    'left': '.tooltip-left',
  };
  $.each(tooltipTypes, function(key, value) {
    $(value).tooltipster({
      side: key,
      theme: tooltipTheme,
      delay: 0,
      contentAsHTML: true,
      debug: false,
    });
  });
};
